/* ============================================================================
FILE: po-katupirsia5-ayeemine-texts-fr-en-es-20260312.js

MODE: TRILINGUE (FR/EN/ES) + protection lexicale stricte
API:  window.PoK5AyeemineTextsFR_EN_ES_20260312
ROOT: .po-k5-section[data-po-k5]

RÔLE:
- injecte le contenu FR/EN/ES dans les slots data-po-slot
- conserve les termes du lexique canonique en FR, quelle que soit la langue
- verrouille la traduction automatique sur le bloc
- compat Shopify / multi-instances
- alias compat : window.GoodyTwinLang
============================================================================ */

(function () {
  "use strict";

  if (window.__PO_K5_AYEEMINE_TEXTS_20260312__) return;
  window.__PO_K5_AYEEMINE_TEXTS_20260312__ = true;
  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-k5-section[data-po-k5="ayeemine"]';

  function clampStr(v) {
    return v == null ? "" : String(v);
  }

  function escapeHTML(s) {
    return clampStr(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function normLang(raw) {
    var v = clampStr(raw).toLowerCase().trim();
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang() {
    try {
      var v = normLang(localStorage.getItem(STORAGE_KEY));
      if (v) return v;
    } catch (e) {}
    try {
      var v2 = normLang(localStorage.getItem(STORAGE_KEY_COMPAT));
      if (v2) return v2;
    } catch (e) {}
    return "";
  }

  function storeLang(lang) {
    var v = normLang(lang) || "fr";
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
    try { localStorage.setItem(STORAGE_KEY_COMPAT, v); } catch (e) {}
    try { document.documentElement.setAttribute("lang", v); } catch (e) {}
    return v;
  }

  function detectBrowserLang() {
    try {
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(n);
      if (v) return v;
    } catch (e) {}
    return "fr";
  }

  function getLang() {
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function notifyLocaleChanged() {
    try {
      window.dispatchEvent(new Event("po:locale-changed"));
    } catch (e) {
      try {
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      } catch (_e) {}
    }
  }

  function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v) {
    if (!v) return;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === v) return;
    }
    arr.push(v);
  }

  function buildVariants(term) {
    var out = [];
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t);

    var a1 = t.replace(/’/g, "'");
    var a2 = t.replace(/'/g, "’");
    uniqPush(out, a1);
    uniqPush(out, a2);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1);
    uniqPush(out, oe2);

    uniqPush(out, oe1.replace(/’/g, "'"));
    uniqPush(out, oe1.replace(/'/g, "’"));
    uniqPush(out, oe2.replace(/’/g, "'"));
    uniqPush(out, oe2.replace(/'/g, "’"));

    return out;
  }

  function getSimplifiedLexiqueFRList() {
    try {
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) {
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    } catch (e) {}
    try {
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)) {
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    } catch (e) {}
    try {
      if (window.PO_LEXIQUE_SIMPLIFIE && window.PO_LEXIQUE_SIMPLIFIE.meta && Array.isArray(window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr)) {
        return window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr.slice();
      }
    } catch (e) {}
    try {
      if (Array.isArray(window.PO_LEXIQUE_SIMPLIFIE_FR)) {
        return window.PO_LEXIQUE_SIMPLIFIE_FR.slice();
      }
    } catch (e) {}

    return [
      "Posœnnoïa",
      "Posœnnoïsme",
      "Posœnnoïal",
      "Système posœnnoïal",
      "Organon posœnnoïal",
      "Posœnnoïamie",
      "Posœnnomia",
      "Katûpirsia",
      "Katûvýs",
      "Katûsýs",
      "Katûvýsqun",
      "Katûvýsissence",
      "Isqun",
      "Threnisqun",
      "Ennéagone régulateur",
      "Sceau d’Équiphase",
      "Sceau de Syntonie",
      "Sceau d’Aísthisi",
      "Sceau d’Anépôron",
      "Sceau d’Ifẹ̀",
      "Sceau d’Ayeẹmí",
      "Sceau d’Ọ̀rọ̀yuyay",
      "Sceau de Yuyarina",
      "Sceau d’Œndomare",
      "Ēkuphasa",
      "Syntōnēa",
      "Aísthēra",
      "Anēporon",
      "Ifẹ̀riya",
      "Ayeẹmīnê",
      "Ọ̀rōyuyān",
      "Yuyarīnâ",
      "Œndomarê",
      "Taxiêlîs",
      "Tiqqunbahu",
      "Takimarah",
      "Ušôprogalenmestûd",
      "Pistis Chraomai",
      "RéZonans",
      "RéZonanser",
      "RéZoindre",
      "Aliœvolution",
      "Péroptissimisme",
      "Illusion",
      "Addition synchrêtique",
      "Instantané multiple",
      "Superposition de perspectives",
      "Sujet pluriel",
      "Méditations Posœnnoïales",
      "Accords Posœnnoïaux",
      "Temporalité élargie",
      "Temporalité éclatée",
      "Stratification d’expériences",
      "Expérience fragmentée",
      "Conscientisation introspective",
      "Conscientisation dynamique",
      "Conscience vibratoire",
      "Lucidité critique",
      "Lucidité structurante",
      "Adaptabilité critique",
      "Adaptabilité ouverte",
      "Approche fluide et adaptative",
      "Déterminisme du choix",
      "Myrte décisif",
      "Néotaxie",
      "Identité évolutive",
      "Exploration de l’inconnu",
      "Miroirs posœnnoïaux",
      "Piliers posœnnoïaux",
      "Résonance éthique",
      "Fréquence 492",
      "Fréquence-guide",
      "Nombre-guide",
      "Humanus",
      "MOCoN",
      "Àpákan"
    ];
  }

  function buildProtectMatcher() {
    var base = getSimplifiedLexiqueFRList();
    var variants = [];

    for (var i = 0; i < base.length; i++) {
      var list = buildVariants(base[i]);
      for (var j = 0; j < list.length; j++) uniqPush(variants, list[j]);
    }

    variants.sort(function (a, b) { return b.length - a.length; });

    var parts = [];
    for (var k = 0; k < variants.length; k++) {
      parts.push(escapeRegExp(variants[k]));
    }

    if (!parts.length) return null;

    try {
      return new RegExp("(" + parts.join("|") + ")", "g");
    } catch (e) {
      return null;
    }
  }

  var __PO_PROTECT_RE__ = null;

  var CANONICAL_OVERRIDES = [
    [/Guide-number/gi, "Nombre-guide"],
    [/Guide number/gi, "Nombre-guide"],
    [/N[úu]mero-gu[ií]a/gi, "Nombre-guide"],
    [/Guide-frequency/gi, "Fréquence-guide"],
    [/Guide frequency/gi, "Fréquence-guide"],
    [/Frecuencia-gu[ií]a/gi, "Fréquence-guide"],
    [/Frequency 111/gi, "Fréquence d’alignement 111"],
    [/Frecuencia 111/gi, "Fréquence d’alignement 111"],
    [/Seal of Ayeẹmí/gi, "Sceau d’Ayeẹmí"],
    [/Sello de Ayeẹmí/gi, "Sceau d’Ayeẹmí"],
    [/Threnisqun entity/gi, "Entité de Threnisqun"],
    [/Entidad del Threnisqun/gi, "Entité de Threnisqun"],
    [/Katûvýsian syntonies/gi, "Syntonies Katûvýsiennes"],
    [/Sinton[ií]as Katûvýsiennes/gi, "Syntonies Katûvýsiennes"],
    [/Atemporal memories/gi, "mémoires atemporelles"],
    [/Memorias atemporales/gi, "mémoires atemporelles"],
    [/Ancestral lineages/gi, "lignées invisibles"],
    [/Linajes invisibles/gi, "lignées invisibles"]
  ];

  function enforceCanonicalFrench(src) {
    var out = clampStr(src);
    if (!out) return "";
    for (var i = 0; i < CANONICAL_OVERRIDES.length; i++) {
      out = out.replace(CANONICAL_OVERRIDES[i][0], CANONICAL_OVERRIDES[i][1]);
    }
    return out;
  }

  function protectLexiconInHTML(html) {
    var src = enforceCanonicalFrench(html);
    if (!src) return "";

    if (!__PO_PROTECT_RE__) __PO_PROTECT_RE__ = buildProtectMatcher();
    if (!__PO_PROTECT_RE__) return src;

    var out = src.replace(__PO_PROTECT_RE__, function (m) {
      return '<span translate="no" class="po-lex-protect notranslate">' + m + "</span>";
    });

    out = out.replace(/([0-9A-Za-zÀ-ÖØ-öø-ÿ])(<span translate="no" class="po-lex-protect notranslate">)/g, "$1 $2");
    out = out.replace(/(<\/span>)([0-9A-Za-zÀ-ÖØ-öø-ÿ])/g, "$1 $2");
    out = out.replace(/(<\/span>)(<[^\/\s>])/g, "$1 $2");
    out = out.replace(/([^\s>])(<span translate="no" class="po-lex-protect notranslate">)/g, function (_m, a, b) {
      if (a === " " || a === ">") return a + b;
      return a + " " + b;
    });

    return out;
  }

  function setHTML(el, html) {
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(html);
  }

  function setText(el, txt) {
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(escapeHTML(enforceCanonicalFrench(txt)));
  }

  function setImg(el, data) {
    if (!el) return;
    var src = data && data.src ? data.src : "";
    var alt = enforceCanonicalFrench(data && data.alt ? data.alt : "");
    if (src) {
      el.src = src;
      el.alt = alt;
      el.removeAttribute("hidden");
      try { el.style.display = ""; } catch (e) {}
    } else {
      el.setAttribute("hidden", "");
      try { el.style.display = "none"; } catch (e) {}
    }
  }

  var CONTENT = {
    fr: {
      title: "Ayeẹmīnê",
      kicker: "Entité isqunienne de Threnisqun — transmutation des mémoires atemporelles et réinscription du souffle ancien dans le présent.",
      title_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Aye_mine_2_copie.png?v=1772923595", alt: "Idéogramme de Ayeẹmīnê" },

      h_def: "Définition canonique",

      chip_1: "Sceau associé : Sceau d’Ayeẹmí",
      chip_1_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Aye_mi_111_2.png?v=1772902150", alt: "Sceau d’Ayeẹmí" },
      chip_2: "Fréquence d’alignement 111",
      chip_2_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_111.png?v=1773449250", alt: "Nombre-guide 111" },
      chip_3: "Entité de Threnisqun",
      chip_3_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/threnisqun_2_copie.png?v=1772883862", alt: "Entité de Threnisqun" },

      def_short:
        "<strong>Ayeẹmīnê</strong> accueille, active et transmute les mémoires anciennes — personnelles, collectives, transversales et non encodées — afin qu’elles redeviennent souffle vivant, énergie intégrée et lumière opérante dans le présent.",

      def_long:
        "<p><strong>Ayeẹmīnê</strong> est l’entité posœnnoïale de transmutation des <strong>mémoires atemporelles</strong>, émanée du <strong>Sceau d’Ayeẹmí</strong>. Elle agit lorsque remonte une mémoire sans langage, un héritage enfoui, une charge ancestrale ou une réminiscence difficile à habiter.</p>" +
        "<p>La ligne d’usage canonique est explicite : <strong>Ayeẹmīnê</strong> n’archive pas, elle libère. Elle rend à la mémoire enfouie la qualité d’un flux vivant, respirable, capable de redevenir présence et passage.</p>",

      h_grid: "Structure vibratoire",
      grid_type_label: "Type",
      grid_type_value: "Entité du Threnisqun associée au <strong>Sceau d’Ayeẹmí</strong>",
      grid_freq_label: "Nombre-guide",
      grid_freq_value: "111",
      grid_scope_label: "Axes et déploiement",
      grid_scope_value:
        "<ul>" +
        "<li>Transmutation des mémoires atemporelles</li>" +
        "<li>Résurgence mémorielle, ancestralité, souffle ancien, lignées invisibles</li>" +
        "<li>Alignement tripolaire : mémoire du corps, mémoire du souffle, mémoire du sens</li>" +
        "</ul>",

      h_intro: "Statut vibratoire",
      p_intro:
        "<p><strong>Ayeẹmīnê</strong> accueille, active et transmute les mémoires anciennes dans leurs régimes multiples : personnelles — traumatismes, oublis, gestes enfouis —, collectives — histoire, généalogie, mémoire culturelle —, transversales — karmiques, spirituelles, vibratoires —, et jusqu’aux mémoires invisibles ou non encodées.</p>" +
        "<p>Son nom fusionne <strong>Ayeẹmí</strong>, forme yorùbá associée à l’âme ou au souffle incarné, et <strong>-nê</strong>, marque d’intériorisation douce. Le sens formulé dans le corpus est : « Celle qui redonne souffle aux mémoires dormantes pour qu’elles deviennent lumière ».</p>",

      h_actions: "Fonctions rituelles",
      actions:
        "<ol>" +
        "<li>Faire émerger les mémoires latentes, atemporelles ou non digérées.</li>" +
        "<li>Transmuter la douleur mémorielle en énergie de régénération.</li>" +
        "<li>Soutenir les rituels de passage intergénérationnels.</li>" +
        "<li>Stabiliser les réminiscences traumatiques afin d’en extraire la charge vivifiante.</li>" +
        "<li>Activer des lignées spirituelles et vibratoires oubliées.</li>" +
        "</ol>",

      h_phrase: "Phrase opérative",
      phrase:
        "<p>« Ayeẹmīnê : je tiens la terre, je laisse le souffle toucher la mémoire obscure, et la lignée redevient lumière dans le présent. »</p>",

      h_table: "Tableau d’usage",
      table_head_1: "Situation",
      table_head_2: "Signe",
      table_head_3: "Action de Ayeẹmīnê",
      table_rows:
        "<tr><td>Résurgence mémorielle inexpliquée</td><td>Souvenir ancien ou flou, sans formulation</td><td>Accueille la remontée et la rend respirable</td></tr>" +
        "<tr><td>Charge ancestrale active</td><td>Poids de lignée, présence transgénérationnelle</td><td>Transmute la charge en énergie de régénération</td></tr>" +
        "<tr><td>Rituel de passage intergénérationnel</td><td>Veille, transmission, franchissement symbolique</td><td>Soutient le passage et la continuité du souffle</td></tr>" +
        "<tr><td>Réminiscence traumatique</td><td>Trace vive, mémoire non digérée</td><td>Stabilise et extrait la charge vivifiante</td></tr>",

      h_entite: "Ayeẹmīnê",
      entite_kicker: "Émanation isqunienne du Sceau d’Ayeẹmí",
      entite_body:
        "<p><strong>Ayeẹmīnê</strong> circule entre les temps comme gardienne vibratoire des couloirs mnésiques. Elle traverse les mondes sans sanctuariser la trace ni la dissoudre. Son action vise l’incarnation énergétique : la mémoire devient fragment vivant, réinscrit dans le souffle.</p>" +
        "<p>La fréquence <strong>111</strong>, triple de l’unité, structure un alignement tripolaire : mémoire du corps, mémoire du souffle, mémoire du sens. L’entité retisse ainsi les mémoires éparses en vortex doux d’intégration poïétique.</p>",

      h_ritual: "Rituel d’activation",
      ritual_name_label: "Nom",
      ritual_name_value: "Larmes d’argile et spirales de souffle",
      ritual_steps:
        "<ol>" +
        "<li>Préparer un petit récipient contenant un peu de terre ou d’argile.</li>" +
        "<li>Tenir le récipient dans la main gauche, la main droite posée sur le front.</li>" +
        "<li>Fermer les yeux et respirer trois fois, en laissant venir un souvenir ancien ou flou.</li>" +
        "<li>Prononcer lentement : Aye… ẹ… mīnê…</li>" +
        "<li>À la fin du rituel, souffler doucement sur la terre et la déposer à la racine d’un arbre.</li>" +
        "</ol>",

      h_moments: "Moments privilégiés",
      moments:
        "<ul>" +
        "<li>Lors d’un travail de mémoire personnelle ou collective</li>" +
        "<li>Quand une mémoire ancienne émerge sans pouvoir être formulée</li>" +
        "<li>Pendant une veille funéraire, un passage de génération ou une création poïétique en lien avec les ancêtres</li>" +
        "</ul>",

      h_syntony: "Syntonies Katûvýsiennes",
      syntony:
        "<ul>" +
        "<li><strong>Katûvýsissence</strong> — activation et stabilisation des mémoires spiralées</li>" +
        "<li><strong>Tiqqunbahu</strong> — fragmentation des mémoires anciennes en motifs recomposables</li>" +
        "<li><strong>Ušôprogalenmestûd</strong> — passage vibratoire entre dimensions mémorielles visibles et invisibles</li>" +
        "<li><strong>Posœnnomia</strong> — rituels liés aux lignées, aux ancêtres et aux résurgences collectives</li>" +
        "<li><strong>Conscientisation introspective</strong> — intégration intérieure de la mémoire comme trace vivante</li>" +
        "</ul>",

      cta_translate: "Proposer une traduction du concept"
    },

    en: {
      title: "Ayeẹmīnê",
      kicker: "Entité de Threnisqun — transmutation of atemporal memories and reinscription of ancient breath into the present.",
      title_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Aye_mine_2_copie.png?v=1772923595", alt: "Idéogramme de Ayeẹmīnê" },

      h_def: "Canonical definition",

      chip_1: "Sceau associé : Sceau d’Ayeẹmí",
      chip_1_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Aye_mi_111_2.png?v=1772902150", alt: "Sceau d’Ayeẹmí" },
      chip_2: "Fréquence d’alignement 111",
      chip_2_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_111.png?v=1773449250", alt: "Nombre-guide 111" },
      chip_3: "Entité de Threnisqun",
      chip_3_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/threnisqun_2_copie.png?v=1772883862", alt: "Entité de Threnisqun" },

      def_short:
        "<strong>Ayeẹmīnê</strong> receives, activates, and transmutes ancient memories — personal, collective, transversal, and unencoded — so that they may become living breath again, integrated energy, and operative light within the present.",

      def_long:
        "<p><strong>Ayeẹmīnê</strong> is the posœnnoïal entity of transmutation of <strong>atemporal memories</strong>, emanated from the <strong>Sceau d’Ayeẹmí</strong>. It acts when a memory rises without language, when an inheritance remains buried, when an ancestral charge persists, or when a reminiscence becomes difficult to inhabit.</p>" +
        "<p>The canonical line of use is explicit: <strong>Ayeẹmīnê</strong> does not archive, it liberates. It restores to buried memory the quality of a living, breathable flux, able to become presence and passage again.</p>",

      h_grid: "Vibratory structure",
      grid_type_label: "Type",
      grid_type_value: "Entité de Threnisqun associated with the <strong>Sceau d’Ayeẹmí</strong>",
      grid_freq_label: "Nombre-guide",
      grid_freq_value: "111",
      grid_scope_label: "Axes and deployment",
      grid_scope_value:
        "<ul>" +
        "<li>Transmutation of atemporal memories</li>" +
        "<li>Memorial resurgence, ancestry, ancient breath, invisible lineages</li>" +
        "<li>Tripolar alignment: memory of the body, memory of the breath, memory of meaning</li>" +
        "</ul>",

      h_intro: "Vibratory status",
      p_intro:
        "<p><strong>Ayeẹmīnê</strong> receives, activates, and transmutes ancient memories in their multiple regimes: personal — traumas, forgotten gestures, buried traces —, collective — history, genealogy, cultural memory —, transversal — karmic, spiritual, vibratory —, and even invisible or unencoded memories.</p>" +
        "<p>Its name fuses <strong>Ayeẹmí</strong>, a Yorùbá form associated with the soul or incarnated breath, and <strong>-nê</strong>, a mark of gentle interiorization. The meaning formulated in the corpus is: “She who gives breath back to sleeping memories so that they may become light.”</p>",

      h_actions: "Ritual functions",
      actions:
        "<ol>" +
        "<li>Bring forth latent, atemporal, or undigested memories.</li>" +
        "<li>Transmute memorial pain into regenerative energy.</li>" +
        "<li>Support intergenerational rites of passage.</li>" +
        "<li>Stabilize traumatic reminiscences in order to extract their life-giving charge.</li>" +
        "<li>Activate forgotten spiritual and vibratory lineages.</li>" +
        "</ol>",

      h_phrase: "Operative phrase",
      phrase:
        "<p>“Ayeẹmīnê: I hold the earth, I let the breath touch obscure memory, and the lineage becomes light again in the present.”</p>",

      h_table: "Usage table",
      table_head_1: "Situation",
      table_head_2: "Sign",
      table_head_3: "Action of Ayeẹmīnê",
      table_rows:
        "<tr><td>Unexplained memorial resurgence</td><td>Ancient or blurred memory, without formulation</td><td>Receives the rise and makes it breathable</td></tr>" +
        "<tr><td>Active ancestral charge</td><td>Weight of lineage, transgenerational presence</td><td>Transmutes the charge into regenerative energy</td></tr>" +
        "<tr><td>Intergenerational rite of passage</td><td>Vigil, transmission, symbolic crossing</td><td>Supports passage and continuity of breath</td></tr>" +
        "<tr><td>Traumatic reminiscence</td><td>Living trace, undigested memory</td><td>Stabilizes and extracts the vivifying charge</td></tr>",

      h_entite: "Ayeẹmīnê",
      entite_kicker: "Émanation isqunienne du Sceau d’Ayeẹmí",
      entite_body:
        "<p><strong>Ayeẹmīnê</strong> moves between times as a vibratory guardian of mnemonic corridors. It crosses worlds without sanctuarizing the trace or dissolving it. Its action aims at energetic incarnation: memory becomes a living fragment, reinscribed into breath.</p>" +
        "<p>The frequency <strong>111</strong>, triple unity, structures a tripolar alignment: memory of the body, memory of the breath, memory of meaning. The entity rewoven scattered memories into gentle vortices of poietic integration.</p>",

      h_ritual: "Activation ritual",
      ritual_name_label: "Name",
      ritual_name_value: "Larmes d’argile et spirales de souffle",
      ritual_steps:
        "<ol>" +
        "<li>Prepare a small container holding a little earth or clay.</li>" +
        "<li>Hold the container in the left hand, with the right hand placed on the forehead.</li>" +
        "<li>Close the eyes and breathe three times, allowing an old or blurred memory to arise.</li>" +
        "<li>Pronounce slowly: Aye… ẹ… mīnê…</li>" +
        "<li>At the end of the ritual, breathe softly onto the earth and place it at the root of a tree.</li>" +
        "</ol>",

      h_moments: "Privileged moments",
      moments:
        "<ul>" +
        "<li>During personal or collective memory work</li>" +
        "<li>When an ancient memory emerges without being formulable</li>" +
        "<li>During a funeral vigil, a generational passage, or poïetic creation in relation with the ancestors</li>" +
        "</ul>",

      h_syntony: "Syntonies Katûvýsiennes",
      syntony:
        "<ul>" +
        "<li><strong>Katûvýsissence</strong> — activation and stabilization of spiral memories</li>" +
        "<li><strong>Tiqqunbahu</strong> — fragmentation of ancient memories into recomposable motifs</li>" +
        "<li><strong>Ušôprogalenmestûd</strong> — vibratory passage between visible and invisible memorial dimensions</li>" +
        "<li><strong>Posœnnomia</strong> — rituals linked to lineages, ancestors, and collective resurgences</li>" +
        "<li><strong>Conscientisation introspective</strong> — inner integration of memory as a living trace</li>" +
        "</ul>",

      cta_translate: "Suggest a translation of the concept"
    },

    es: {
      title: "Ayeẹmīnê",
      kicker: "Entité de Threnisqun — transmutación de las memorias atemporales y reinscripción del aliento antiguo en el presente.",
      title_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Aye_mine_2_copie.png?v=1772923595", alt: "Idéogramme de Ayeẹmīnê" },

      h_def: "Definición canónica",

      chip_1: "Sceau associé : Sceau d’Ayeẹmí",
      chip_1_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Aye_mi_111_2.png?v=1772902150", alt: "Sceau d’Ayeẹmí" },
      chip_2: "Fréquence d’alignement 111",
      chip_2_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_111.png?v=1773449250", alt: "Nombre-guide 111" },
      chip_3: "Entité de Threnisqun",
      chip_3_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/threnisqun_2_copie.png?v=1772883862", alt: "Entité de Threnisqun" },

      def_short:
        "<strong>Ayeẹmīnê</strong> acoge, activa y transmuta las memorias antiguas — personales, colectivas, transversales o no codificadas — para que vuelvan a ser aliento vivo, energía integrada y luz operativa en el presente.",

      def_long:
        "<p><strong>Ayeẹmīnê</strong> es la entidad posœnnoïal de transmutación de las <strong>memorias atemporales</strong>, emanada del <strong>Sceau d’Ayeẹmí</strong>. Actúa cuando una memoria asciende sin lenguaje, cuando una herencia permanece enterrada, cuando una carga ancestral persiste o cuando una reminiscencia se vuelve difícil de habitar.</p>" +
        "<p>La línea canónica de uso es explícita: <strong>Ayeẹmīnê</strong> no archiva, libera. Devuelve a la memoria enterrada la cualidad de un flujo vivo, respirable, capaz de volver a ser presencia y paso.</p>",

      h_grid: "Estructura vibratoria",
      grid_type_label: "Tipo",
      grid_type_value: "Entité de Threnisqun asociada al <strong>Sceau d’Ayeẹmí</strong>",
      grid_freq_label: "Nombre-guide",
      grid_freq_value: "111",
      grid_scope_label: "Ejes y despliegue",
      grid_scope_value:
        "<ul>" +
        "<li>Transmutación de las memorias atemporales</li>" +
        "<li>Resurgencia memorial, ancestralidad, aliento antiguo, lignées invisibles</li>" +
        "<li>Alineación tripolar: mémoire du corps, mémoire du souffle, mémoire du sens</li>" +
        "</ul>",

      h_intro: "Estatuto vibratorio",
      p_intro:
        "<p><strong>Ayeẹmīnê</strong> acoge, activa y transmuta las memorias antiguas en sus regímenes múltiples: personales — traumas, olvidos, gestos sepultados —, colectivas — historia, genealogía, memoria cultural —, transversales — kármicas, espirituales, vibratorias —, e incluso memorias invisibles o no codificadas.</p>" +
        "<p>Su nombre fusiona <strong>Ayeẹmí</strong>, forma yorùbá asociada al alma o al aliento encarnado, y <strong>-nê</strong>, marca de interiorización suave. El sentido formulado en el corpus es: « Aquella que devuelve aliento a las memorias dormidas para que se vuelvan luz ».</p>",

      h_actions: "Funciones rituales",
      actions:
        "<ol>" +
        "<li>Hacer emerger memorias latentes, atemporales o no digeridas.</li>" +
        "<li>Transmutar el dolor memorial en energía de regeneración.</li>" +
        "<li>Sostener rituales de paso intergeneracionales.</li>" +
        "<li>Estabilizar reminiscencias traumáticas para extraer su carga vivificante.</li>" +
        "<li>Activar linajes espirituales y vibratorios olvidados.</li>" +
        "</ol>",

      h_phrase: "Frase operativa",
      phrase:
        "<p>« Ayeẹmīnê: sostengo la tierra, dejo que el aliento toque la memoria oscura, y el linaje vuelve a ser luz en el presente. »</p>",

      h_table: "Tabla de uso",
      table_head_1: "Situación",
      table_head_2: "Signo",
      table_head_3: "Acción de Ayeẹmīnê",
      table_rows:
        "<tr><td>Resurgencia memorial inexplicable</td><td>Recuerdo antiguo o borroso, sin formulación</td><td>Acoge el ascenso y lo vuelve respirable</td></tr>" +
        "<tr><td>Carga ancestral activa</td><td>Peso de linaje, presencia transgeneracional</td><td>Transmuta la carga en energía de regeneración</td></tr>" +
        "<tr><td>Ritual de paso intergeneracional</td><td>Vigilia, transmisión, cruce simbólico</td><td>Sostiene el paso y la continuidad del aliento</td></tr>" +
        "<tr><td>Reminiscencia traumática</td><td>Huella viva, memoria no digerida</td><td>Estabiliza y extrae la carga vivificante</td></tr>",

      h_entite: "Ayeẹmīnê",
      entite_kicker: "Émanation isqunienne du Sceau d’Ayeẹmí",
      entite_body:
        "<p><strong>Ayeẹmīnê</strong> circula entre los tiempos como guardiana vibratoria de los corredores mnésicos. Cruza los mundos sin santuarizar la huella ni disolverla. Su acción apunta a la encarnación energética: la memoria se vuelve fragmento vivo, reinscrito en el aliento.</p>" +
        "<p>La frecuencia <strong>111</strong>, triple de la unidad, estructura una alineación tripolar: mémoire du corps, mémoire du souffle, mémoire du sens. La entidad reteje así las memorias dispersas en vórtices suaves de integración poiética.</p>",

      h_ritual: "Ritual de activación",
      ritual_name_label: "Nombre",
      ritual_name_value: "Larmes d’argile et spirales de souffle",
      ritual_steps:
        "<ol>" +
        "<li>Preparar un pequeño recipiente con un poco de tierra o de arcilla.</li>" +
        "<li>Sostener el recipiente con la mano izquierda, con la mano derecha apoyada sobre la frente.</li>" +
        "<li>Cerrar los ojos y respirar tres veces, dejando venir un recuerdo antiguo o borroso.</li>" +
        "<li>Pronunciar lentamente: Aye… ẹ… mīnê…</li>" +
        "<li>Al final del ritual, soplar suavemente sobre la tierra y depositarla en la raíz de un árbol.</li>" +
        "</ol>",

      h_moments: "Momentos privilegiados",
      moments:
        "<ul>" +
        "<li>Durante un trabajo de memoria personal o colectiva</li>" +
        "<li>Cuando emerge una memoria antigua sin poder formularse</li>" +
        "<li>Durante una vigilia funeraria, un paso generacional o una creación poiética vinculada a los ancestros</li>" +
        "</ul>",

      h_syntony: "Syntonies Katûvýsiennes",
      syntony:
        "<ul>" +
        "<li><strong>Katûvýsissence</strong> — activación y estabilización de las memorias espirales</li>" +
        "<li><strong>Tiqqunbahu</strong> — fragmentación de memorias antiguas en motivos recomponibles</li>" +
        "<li><strong>Ušôprogalenmestûd</strong> — paso vibratorio entre dimensiones memoriales visibles e invisibles</li>" +
        "<li><strong>Posœnnomia</strong> — rituales ligados a linajes, ancestros y resurgencias colectivas</li>" +
        "<li><strong>Conscientisation introspective</strong> — integración interior de la memoria como huella viva</li>" +
        "</ul>",

      cta_translate: "Proposer une traduction du concept"
    }
  };

  function syncDocumentLang(lang) {
    try {
      document.documentElement.setAttribute("lang", lang || "fr");
    } catch (e) {}
  }

  /* ========================================================================
     AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
  ======================================================================== */
  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;

  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    activeKey: "",
    activeButtons: []
  };

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function getAudioUILabels(lang) {
    return AUDIO_UI[normLang(lang) || "fr"] || AUDIO_UI.fr;
  }

  function stopAudio() {
    if (PO_AUDIO_SYNTH) {
      try { PO_AUDIO_SYNTH.cancel(); } catch (e) {}
    }
    for (var i = 0; i < PO_AUDIO_STATE.activeButtons.length; i++) {
      try {
        PO_AUDIO_STATE.activeButtons[i].setAttribute("data-po-audio-state", "idle");
      } catch (e) {}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.activeButtons = [];
  }

  function setAudioButtonsState(root, lang, activeKey) {
    var labels = getAudioUILabels(lang);
    var all = root.querySelectorAll(".po-audio-btn");
    PO_AUDIO_STATE.activeButtons = [];
    for (var i = 0; i < all.length; i++) {
      var btn = all[i];
      var kind = btn.getAttribute("data-po-audio-kind") || "block";
      var key = btn.getAttribute("data-po-audio-key") || "";
      var active = activeKey && key === activeKey;
      btn.setAttribute("data-po-audio-state", active ? "playing" : "idle");
      btn.textContent = active ? labels.stop : (kind === "general" ? labels.general : labels.block);
      if (active) PO_AUDIO_STATE.activeButtons.push(btn);
    }
  }

  function audioTextFromNode(node) {
    if (!node) return "";
    var clone = node.cloneNode(true);
    var junk = clone.querySelectorAll(".po-audio-btn, script, style");
    for (var i = 0; i < junk.length; i++) {
      if (junk[i] && junk[i].parentNode) junk[i].parentNode.removeChild(junk[i]);
    }
    var txt = "";
    try { txt = clone.innerText || clone.textContent || ""; } catch (e) { txt = clone.textContent || ""; }
    return clampStr(txt).replace(/\s+/g, " ").replace(/\s([,;:.!?])/g, "$1").trim();
  }

  function splitTextForSpeech(text) {
    var src = clampStr(text).replace(/\s+/g, " ").trim();
    if (!src) return [];
    var parts = src.match(/[^.!?]+[.!?…]?/g) || [src];
    var maxLen = 210;
    var out = [];
    var cur = "";
    for (var i = 0; i < parts.length; i++) {
      var piece = clampStr(parts[i]).trim();
      if (!piece) continue;
      if (!cur) {
        cur = piece;
        continue;
      }
      if ((cur + " " + piece).length <= maxLen) {
        cur += " " + piece;
      } else {
        out.push(cur);
        cur = piece;
      }
    }
    if (cur) out.push(cur);
    return out;
  }

  function ensureDetailsOpen(details) {
    if (!details) return;
    try { details.open = true; } catch (e) {}
  }

  function getRootGeneralText(root) {
    var keys = ["title", "kicker", "h_def", "def_short", "def_long"];
    var chunks = [];
    for (var i = 0; i < keys.length; i++) {
      var el = root.querySelector('[data-po-slot="' + keys[i] + '"]');
      var txt = audioTextFromNode(el);
      if (txt) chunks.push(txt);
    }
    return chunks.join(" ");
  }

  function getBlockText(details) {
    if (!details) return "";
    var summary = details.querySelector(".po-lex-summary");
    var bodyParts = [];
    var title = audioTextFromNode(summary);
    if (title) bodyParts.push(title);
    var children = details.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].tagName && children[i].tagName.toLowerCase() === "summary") continue;
      var txt = audioTextFromNode(children[i]);
      if (txt) bodyParts.push(txt);
    }
    return bodyParts.join(" ");
  }

  function buildAudioUnits(root, startIndex) {
    var units = [];
    if (startIndex === 0) {
      var general = getRootGeneralText(root);
      if (general) units.push({ key: "general", kind: "general", text: general });
    }
    var details = root.querySelectorAll(".po-lex-details");
    for (var i = startIndex; i < details.length; i++) {
      var txt = getBlockText(details[i]);
      if (!txt) continue;
      units.push({ key: "block-" + i, kind: "block", text: txt, details: details[i] });
    }
    return units;
  }

  function speakChunks(lang, chunks, onDone) {
    if (!PO_AUDIO_SYNTH || !chunks.length) {
      if (typeof onDone === "function") onDone();
      return;
    }

    var voices = [];
    try { voices = PO_AUDIO_SYNTH.getVoices() || []; } catch (e) { voices = []; }
    var langTag = (normLang(lang) || "fr");
    var preferred = { fr: "fr-FR", en: "en-US", es: "es-ES" }[langTag] || "fr-FR";
    var voice = null;
    for (var i = 0; i < voices.length; i++) {
      var vl = (voices[i].lang || "").toLowerCase();
      if (vl.indexOf(langTag) === 0) { voice = voices[i]; break; }
    }

    function next(idx) {
      if (idx >= chunks.length) {
        if (typeof onDone === "function") onDone();
        return;
      }
      var utter = new SpeechSynthesisUtterance(chunks[idx]);
      utter.lang = preferred;
      if (voice) utter.voice = voice;
      utter.rate = 0.98;
      utter.pitch = 1;
      utter.onend = function () { next(idx + 1); };
      utter.onerror = function () { next(idx + 1); };
      try { PO_AUDIO_SYNTH.speak(utter); } catch (e) { next(idx + 1); }
    }

    next(0);
  }

  function playAudioUnits(root, lang, units, activeKey) {
    if (!units || !units.length) return;
    stopAudio();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = units.slice();
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.activeKey = activeKey || units[0].key;
    setAudioButtonsState(root, lang, PO_AUDIO_STATE.activeKey);

    function advance() {
      if (!PO_AUDIO_STATE.units.length || PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length) {
        stopAudio();
        setAudioButtonsState(root, lang, "");
        return;
      }
      var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
      PO_AUDIO_STATE.activeKey = unit.key;
      setAudioButtonsState(root, lang, unit.key);
      if (unit.details) ensureDetailsOpen(unit.details);
      var chunks = splitTextForSpeech(unit.text);
      speakChunks(lang, chunks, function () {
        PO_AUDIO_STATE.unitPos += 1;
        advance();
      });
    }

    advance();
  }

  function makeAudioButton(kind, key, lang) {
    var labels = getAudioUILabels(lang);
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-audio-btn notranslate";
    btn.setAttribute("translate", "no");
    btn.setAttribute("data-po-audio-kind", kind);
    btn.setAttribute("data-po-audio-key", key);
    btn.setAttribute("data-po-audio-state", "idle");
    btn.textContent = kind === "general" ? labels.general : labels.block;
    return btn;
  }

  function injectAudioButtons(root, lang) {
    if (!root) return;

    var old = root.querySelectorAll(".po-audio-btn");
    for (var i = 0; i < old.length; i++) {
      if (old[i] && old[i].parentNode) old[i].parentNode.removeChild(old[i]);
    }

    var generalBtn = makeAudioButton("general", "general", lang);
    var meta = root.querySelector(".po-axis-meta");
    var defShort = root.querySelector('[data-po-slot="def_short"]');
    var firstDetails = root.querySelector(".po-lex-details");

    if (meta && meta.parentNode) {
      meta.parentNode.insertBefore(generalBtn, meta.nextSibling);
    } else if (defShort && defShort.parentNode) {
      defShort.parentNode.insertBefore(generalBtn, defShort);
    } else if (firstDetails && firstDetails.parentNode) {
      firstDetails.parentNode.insertBefore(generalBtn, firstDetails);
    }

    generalBtn.addEventListener("click", function () {
      if (PO_AUDIO_STATE.activeKey === "general") {
        stopAudio();
        setAudioButtonsState(root, lang, "");
        return;
      }
      playAudioUnits(root, lang, buildAudioUnits(root, 0), "general");
    });

    var details = root.querySelectorAll(".po-lex-details");
    for (var j = 0; j < details.length; j++) {
      var summary = details[j].querySelector(".po-lex-summary");
      if (!summary) continue;
      var btn = makeAudioButton("block", "block-" + j, lang);
      btn.addEventListener("click", (function (idx) {
        return function (ev) {
          try { ev.preventDefault(); ev.stopPropagation(); } catch (e) {}
          var key = "block-" + idx;
          if (PO_AUDIO_STATE.activeKey === key) {
            stopAudio();
            setAudioButtonsState(root, lang, "");
            return;
          }
          playAudioUnits(root, lang, buildAudioUnits(root, idx), key);
        };
      })(j));
      summary.appendChild(btn);
    }

    setAudioButtonsState(root, lang, PO_AUDIO_STATE.activeKey);
  }

  function initAudioEverywhere(lang) {
    if (!PO_AUDIO_SYNTH) return;
    stopAudio();
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      injectAudioButtons(roots[i], lang || getLang());
    }
  }

  function applyLangbar(root, lang) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute("data-po-lang") === lang;
      buttons[i].setAttribute("aria-pressed", active ? "true" : "false");
      if (active) buttons[i].classList.add("is-active");
      else buttons[i].classList.remove("is-active");
    }
  }

  function applyContent(root, lang) {
    var c = CONTENT[lang] || CONTENT.fr;

    var htmlSlots = [
      "def_short", "def_long", "grid_type_value", "grid_scope_value", "p_intro", "actions", "phrase",
      "table_rows", "entite_body", "ritual_name_value", "ritual_steps", "moments", "syntony"
    ];

    var imgSlots = ["title_img", "chip_1_img", "chip_2_img", "chip_3_img"];

    Object.keys(c).forEach(function (key) {
      var el = root.querySelector('[data-po-slot="' + key + '"]');
      if (!el) return;

      if (imgSlots.indexOf(key) > -1) {
        setImg(el, c[key]);
        return;
      }

      if (htmlSlots.indexOf(key) > -1) {
        setHTML(el, c[key]);
        return;
      }

      setText(el, c[key]);
    });

    applyLangbar(root, lang);
  }

  function setLang(lang) {
    var safeLang = storeLang(normLang(lang) || "fr");

    syncDocumentLang(safeLang);
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      applyContent(roots[i], safeLang);
    }
    initAudioEverywhere(safeLang);

    notifyLocaleChanged();
    return safeLang;
  }

  function bindLangButtons(root) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      (function (btn) {
        btn.addEventListener("click", function () {
          setLang(btn.getAttribute("data-po-lang"));
        });
      })(buttons[i]);
    }
  }

  function lockTranslation(root) {
    if (!root) return;
    root.setAttribute("translate", "no");
    root.classList.add("notranslate");

    var scope = root.querySelector("[data-po-lex-scope]");
    if (scope) {
      scope.setAttribute("translate", "no");
      scope.classList.add("notranslate");
    }
  }

  function initOne(root) {
    if (!root || root.__poK5AyeemineInit) return;
    root.__poK5AyeemineInit = true;

    lockTranslation(root);
    bindLangButtons(root);
    applyContent(root, getLang());
  }

  function init() {
    var lang = getLang();
    syncDocumentLang(lang);
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
    initAudioEverywhere(lang);
  }

  window.PoK5AyeemineTextsFR_EN_ES_20260312 = {
    init: init,
    getLang: getLang,
    setLang: setLang,
    stopAudio: stopAudio
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = setLang;
  window.GoodyTwinLang.init = init;

  window.addEventListener("po:lexicon-ready", function(){
    try{
      __PO_PROTECT_RE__ = null;
      setLang(getLang());
    }catch(e){}
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
